import { render } from "./GamelistProdTable.vue?vue&type=template&id=7e639690&scoped=true"
import script from "./GamelistProdTable.vue?vue&type=script&lang=js"
export * from "./GamelistProdTable.vue?vue&type=script&lang=js"

import "./GamelistProdTable.vue?vue&type=style&index=0&id=7e639690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e639690"]])

export default __exports__